import { render, staticRenderFns } from "./MakeCopy.vue?vue&type=template&id=3952f502&scoped=true"
import script from "./MakeCopy.vue?vue&type=script&lang=js"
export * from "./MakeCopy.vue?vue&type=script&lang=js"
import style0 from "./MakeCopy.vue?vue&type=style&index=0&id=3952f502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952f502",
  null
  
)

export default component.exports